import { render, staticRenderFns } from "./StepWrapper.vue?vue&type=template&id=51b998f6"
import script from "./StepWrapper.vue?vue&type=script&lang=js"
export * from "./StepWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports